module.exports = __webpack_public_path__ + "img/section-1_bottom_img_other.4b0f7137.png";